import { Typography } from '@/components/UI/Typography'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import type { PointHistoryEntry } from './DialogPointHistory'
import { PointHistoryItem } from './PointHistoryItem'

type Props = {
  items: PointHistoryEntry[]
  /** スタンプ名タップ時に呼ばれる。spotId が null の行はタップ不可になる（#2972） */
  onSelectSpot?: (spotId: number) => void
}

/**
 * ポイント履歴一覧コンポーネント。
 * 履歴がない場合は空メッセージを表示する。
 */
export const PointHistoryList: FC<Props> = ({ items, onSelectSpot }) => {
  const { t } = useTranslation()
  if (items.length === 0) {
    return (
      <Typography variant="caption1" className="py-8 text-center" c="gray.5">
        {t('common.no_data', 'データがありません')}
      </Typography>
    )
  }

  return (
    <ul>
      {items.map((item) => {
        const spotId = item.spotId
        return (
          <li key={item.id}>
            <PointHistoryItem
              label={item.label}
              point={item.point}
              acquiredAt={item.acquiredAt}
              onClick={onSelectSpot && spotId !== null ? () => onSelectSpot(spotId) : undefined}
            />
          </li>
        )
      })}
    </ul>
  )
}
